import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCountries } from '../actions/countries';
import { doSubmitCorporateInstitutionTypeSection } from '../actions/financial-institution';
import FinancialInstitution from '../components/corporate/financial-institution';
export default connect(state => ({
  submitted: state.corporateInstitution.submitCorporateInstitution.submitted,
  submitting: state.corporateInstitution.submitCorporateInstitution.submitting,
  error: state.corporateInstitution.submitCorporateInstitution.error,
  countries: state.countries.fetch
}), dispatch => bindActionCreators({
  doSubmitCorporateInstitutionTypeSection,
  getCountries
}, dispatch))(FinancialInstitution);